// extracted by mini-css-extract-plugin
export default {"subheader":"partners-module__subheader--kqg"};